// 1. Your Data Source
const videos = {
  sectwo: ['kO2hSKLuFNs', 'dRMSKlnqsZI', 'ROFW5k_XV6c', 'Vi0q81AhQmQ'],
};

// 2. The Upgraded Factory
function createVideo(id) {
  const wrapper = document.createElement('div');
  wrapper.className = 'video-wrapper';

  // FIX: Added /vi/ and ${id} wrapper for the thumbnail URL
  const img = document.createElement('img');
  img.src = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
  img.alt = 'Video Thumbnail';
  img.loading = 'lazy';
  
  const playBtn = document.createElement('div');
  playBtn.className = 'play-button';

  wrapper.appendChild(img);
  wrapper.appendChild(playBtn);

  // FIX: Added /embed/ and ${id} wrapper for the video URL
  wrapper.onclick = function() {
    this.innerHTML = `
      <iframe 
        referrerpolicy="strict-origin-when-cross-origin"
        src="https://www.youtube.com/embed/${id}?autoplay=1" 
        frameborder="0" 
        allow="autoplay; encrypted-media" 
        allowfullscreen>
      </iframe>`;
  };

  return wrapper;
}

// 3. The Execution Logic
document.addEventListener('DOMContentLoaded', () => {
  Object.entries(videos).forEach(([section, ids]) => {
    const gallery = document.getElementById(`${section}-gallery`);
    if (gallery) {
      ids.forEach(id => gallery.appendChild(createVideo(id)));
    }
  });
});